var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_1320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.183594,
    width: 40,
    height: 40,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7989 33.3441C32.9589 29.1041 29.4289 25.9341 25.2089 24.4941C28.2289 22.7041 30.2489 19.4241 30.2489 15.6641C30.2489 10.0141 25.6489 5.41406 19.9989 5.41406C14.3489 5.41406 9.74893 10.0141 9.74893 15.6641C9.74893 19.4141 11.7789 22.7041 14.7889 24.4941C10.5689 25.9341 7.03892 29.1041 5.19892 33.3441C4.94892 33.9241 5.20893 34.6041 5.78893 34.8541C6.36893 35.1041 7.04893 34.8441 7.29893 34.2641C9.49893 29.2041 14.4789 25.9341 19.9989 25.9341C25.5189 25.9341 30.4989 29.2041 32.6989 34.2641C32.8889 34.6941 33.3089 34.9541 33.7489 34.9541C33.8989 34.9541 34.0589 34.9241 34.2089 34.8541C34.7889 34.6041 35.0589 33.9241 34.7989 33.3441ZM12.0389 15.6741C12.0389 11.2841 15.6089 7.71406 19.9989 7.71406C24.3889 7.71406 27.9589 11.2841 27.9589 15.6741C27.9589 20.0641 24.3889 23.6341 19.9989 23.6341C15.6089 23.6341 12.0389 20.0641 12.0389 15.6741Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOn);
export default __webpack_public_path__ + "static/media/my_on.8d7b5d21959776c10b53cca9c4e7943d.svg";
export { ForwardRef as ReactComponent };